<template>
  <coverage-page
    :customPageControl="pageControl"
    :customDefaultForm="defaultForm"
    :customNeedValidate="needValidate"
  />
</template>
<script>
import { mapGetters } from "vuex";
import CoveragePage from "./components/CoveragePage.vue";
import { commonMixin } from "@/mixins/common";
export default {
  mixins: [commonMixin],
  name: "MaturityBenefit",
  components: {
    CoveragePage,
  },
  data() {
    return {
      pageControl: {
        pageName: "滿期保險金",
        pageBlock: ["periodMulti", "formulaMulti", "maxSingle"],
        showUpper: false,
        showHint: true,
        showAfter: false,
        showCoverageItems: false,
      },
      defaultForm: {
        periodType: 7,
        form_kind: "903B",
      },
      needValidate: {
        period_upper: false,
      },
    };
  },
  computed: {
    ...mapGetters(["BaseUrl"]),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name === "MaintainForm8") {
        vm.pageControl.settingType = 2;
      }
    });
  },
  watch: {},
  methods: {},
  mounted() {},
};
</script>